import React from 'react'
import PropTypes from 'prop-types'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'
import classNames from 'classnames'

const NavTabs = ({ tabs, active, handleChange, className, position, version, testId }) => (
  <div
    className={classNames(
      'jisr-tabs',
      className,
      version && `version--${version}`,
      position && `position--${position}`,
    )}
  >
    <Tabs
      data-testid={testId}
      value={active}
      onChange={handleChange}
      indicatorColor="primary"
      textColor="primary"
      fullwidth="true"
      // scrollable="true"
      variant="scrollable"
      scrollButtons="auto"
    >
      {tabs.map(
        (tab) =>
          tab && (
            <Tab
              data-testid={tab.testId}
              key={tab.path || tab.value}
              label={
                <div className="flex m-0">
                  {tab.label}
                  {!!tab.badge && <span className="tab-count">{tab.badge}</span>}
                </div>
              }
              data-url={tab.path || tab.value}
              disabled={tab.disabled}
            />
          ),
      )}
    </Tabs>
  </div>
)

NavTabs.propTypes = {
  tabs: PropTypes.arrayOf(Object).isRequired,
  active: PropTypes.number.isRequired,
  testId: PropTypes.string,
  handleChange: PropTypes.func.isRequired,
  className: PropTypes.string,
  position: PropTypes.string,
  version: PropTypes.string,
}
export default NavTabs
